import { User } from 'oidc-client-ts';
import { TOKEN_EXPIRY_THRESHOLD_SECONDS } from './constants';

/**
 * Checks if the token is expired or about to expire (within threshold).
 * @param user - The OIDC user object
 * @param thresholdSeconds - Seconds before expiry to consider "expiring" (default: TOKEN_EXPIRY_THRESHOLD_SECONDS)
 * @returns true if token is expired or will expire within threshold
 */
export function isTokenExpiredOrExpiring(
  user: User | null | undefined,
  thresholdSeconds: number = TOKEN_EXPIRY_THRESHOLD_SECONDS
): boolean {
  if (!user?.expires_at) {
    return true;
  }
  const now = Math.floor(Date.now() / 1000);
  const timeUntilExpiry = user.expires_at - now;
  return timeUntilExpiry <= thresholdSeconds;
}

/**
 * Checks if the token is completely expired.
 * @param user - The OIDC user object
 * @returns true if token is already expired
 */
export function isTokenExpired(user: User | null | undefined): boolean {
  return isTokenExpiredOrExpiring(user, 0);
}
